<template>
  <div>
 
  </div>
</template>

<script>
export default {
  name: 'BiaogeAbout',

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>